<template>
  <g id="bf687369-6c89-4a22-85be-1f52a37fee6e" data-name="map">
    <polygon
      id="b3308a67-a5a2-4f86-8f65-c982c0ab3f9b"
      :data-name="$t('chuo_ku')"
      points="650.565 842.615 601.708 872.564 347.145 681.434 463.772 482.457 617.317 461.577 761.135 669.628 650.565 842.615"
      fill="#f66"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(28) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="a4bbf87c-fd87-4ffd-afcf-6f64746e8d2b"
      :data-name="$t('hanamigawa_ku')"
      points="357.684 364.408 194.567 256.858 530.129 11.597 671.681 164.711 357.684 364.408"
      fill="#f9c"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(29) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="bc3182be-d1d9-4aeb-b8e1-6b8f6f5a7f05"
      :data-name="$t('inage_ku')"
      points="463.772 482.457 357.684 364.408 671.681 164.711 788.966 351.072 684.603 385.383 617.317 461.577 463.772 482.457"
      fill="#f96"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(30) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="f0c3edb2-ef82-4c5c-9dfd-a89a0ec0051a"
      :data-name="$t('wakaba_ku')"
      points="761.135 669.628 617.317 461.577 684.603 385.383 788.966 351.072 1024.373 489.592 1017.898 750.232 761.135 669.628"
      fill="#9c3"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(31) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="a6bba2c1-83e2-45cd-ae15-5f5d7e62559e"
      :data-name="$t('midori_ku')"
      points="650.565 842.615 761.135 669.628 1017.898 750.232 1012.089 872.564 890.208 987.597 650.565 842.615"
      fill="#6c6"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(32) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="bcb33a43-48c7-4e87-ad91-13dc7f5919ff"
      :data-name="$t('mihama_ku')"
      points="194.567 256.858 76.95 398.804 370.928 640.857 463.772 482.457 357.684 364.408 194.567 256.858"
      fill="#6cc"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(33) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
  </g>
</template>

<script>
export default {
  props: ['shopMapIds'],
};
</script>

<style scoped>
.map-presentation {
  stroke: #fff;
  stroke-linejoin: round;
  stroke-width: 8px;
}
</style>
